import type { ReactNode } from "react"
import { Sidebar } from "./sidebar"
import { FlashBanner } from "./flash-banner"

type Props = { children: ReactNode }

// Top-level shell: persistent sidebar + scrollable main content.
// Every authenticated portal page is wrapped in this.
//
// FlashBanner is mounted globally so `flash.notice` / `flash.alert` from
// Portal::ApplicationController#inertia_share surface on EVERY page (not
// just the few that hand-rolled their own banner). It also mirrors each
// flash to the browser console so a missed alert still shows up in
// DevTools.
export function AppShell({ children }: Props) {
  return (
    <div className="flex min-h-screen bg-app-bg text-app-text">
      <Sidebar />
      <main className="flex-1 space-y-6 overflow-x-hidden p-6">
        <FlashBanner />
        {children}
      </main>
    </div>
  )
}
